import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { ngxCsv } from 'ngx-csv/ngx-csv';

import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-asset-report',
  templateUrl: './asset-report.component.html',
  styleUrls: ['./asset-report.component.css']
})
export class AssetReportComponent implements OnInit {

  isLoading: any = false
  objectInfoList: any = []
  searchFilter: any = ""
  fromDate: any = ""
  toDate: any = ""
  status: any = ""

  isFromDate: any = true
  isToDate: any = true
  isStatus: any = false
  isLocation: any = false


  cid: any;
  assetReportIdName: any = "";
  assetsAgingReport: any = "";
  selectedCategoryObj: any = null;
  locationId: any = "";
  locationList: any[] = [];


  // reportsCategory: any = [
  //   {
  //     category: 'Asset Inventory & Lifecycle Reports',
  //     reports: [
  //       { value: 'ASSET_INVENTORY_DETAIL', label: 'Asset Inventory Detail' },
  //       { value: 'ASSET_AGE_PROFILE', label: 'Asset Age Profile' },
  //       { value: 'IN_TRANSIT_ASSETS_DETAIL', label: 'In Transit Assets Detail' },
  //       { value: 'ASSET_CATEGORY_DISTRIBUTION', label: 'Asset Category Distribution' },
  //       { value: 'ASSET_CONDITION_BY_BRANCH', label: 'Asset Condition by Branch' },
  //       { value: 'ASSET_MAKE_MODEL_DENSITY', label: 'Asset Make Model Density' }
  //     ]
  //   },
  //   {
  //     category: 'Financial & Valuation Reports',
  //     reports: [
  //       { value: 'STRAIGHT_LINE_DEPRECIATION_FORECAST', label: 'Straight Line Depreciation Forecast' },
  //       { value: 'ASSET_VALUATION_BY_DEPARTMENT', label: 'Asset Valuation by Department' },
  //       { value: 'HIGH_VALUE_ASSETS_REPORT', label: 'High Value Assets Report' },
  //       { value: 'RETIRED_ASSETS_SALVAGE_AUDIT', label: 'Retired Assets Salvage Audit' },
  //       { value: 'WARRANTY_EXPIRY_ALERT_REPORT', label: 'Warranty Expiry Alert Report' },
  //       { value: 'ACCUMULATED_MAINTENANCE_COST_RATIO', label: 'Accumulated Maintenance Cost Ratio' }
  //     ]
  //   },
  //   {
  //     category: 'Maintenance, Tickets & Repair Reports',
  //     reports: [
  //       { value: 'REPAIR_COST_BY_VENDOR', label: 'Repair Cost by Vendor' },
  //       { value: 'TICKETS_BY_PRIORITY_AND_STATUS', label: 'Tickets by Priority and Status' },
  //       { value: 'MEAN_TIME_TO_REPAIR_MTTR', label: 'Mean Time to Repair (MTTR)' },
  //       { value: 'REPETITIVE_FAILURES_ALERT_LOG', label: 'Repetitive Failures Alert Log' },
  //       { value: 'TICKETS_RESOLVED_BY_TECHNICIAN', label: 'Tickets Resolved by Technician' },
  //       { value: 'PREVENTIVE_MAINTENANCE_ADHERENCE', label: 'Preventive Maintenance Adherence' },
  //       { value: 'TICKET_BACKLOG_AGING', label: 'Ticket Backlog Aging' }
  //     ]
  //   },
  //   {
  //     category: 'IoT, Health Monitoring & Allocations Reports',
  //     reports: [
  //       { value: 'ASSET_HEALTH_MONITORING_UPTIME', label: 'Asset Health Monitoring Uptime' },
  //       { value: 'OFFLINE_MONITORED_ASSETS_ALERT', label: 'Offline Monitored Assets Alert' },
  //       { value: 'ASSET_ALLOCATION_HISTORY_LOG', label: 'Asset Allocation History Log' },
  //       { value: 'STOCK_POINT_INVENTORY_VALUATION', label: 'Stock Point Inventory Valuation' },
  //       { value: 'GEOSPATIAL_ASSET_DENSITY', label: 'Geospatial Asset Density' },
  //       { value: 'OVER_ALLOCATED_STOCK_WARNING', label: 'Over Allocated Stock Warning' }
  //     ]
  //   }
  // ];


  reportsCategory: any = [
    {
      category: 'Asset Inventory & Lifecycle Reports',
      reports: [
        { value: 'ASSET_INVENTORY_DETAIL', label: 'Asset Inventory Detail' },
        { value: 'ASSET_AGE_PROFILE', label: 'Asset Age Profile' },
        // { value: 'ASSET_AGE', label: 'Asset Age' },
        { value: 'ASSET_ACQUISITION_REPORT', label: 'Asset Acquisition Report' },
        { value: 'IN_TRANSIT_ASSETS_DETAIL', label: 'In Transit Assets Detail' },
        { value: 'ASSET_CATEGORY_DISTRIBUTION', label: 'Asset Category Distribution' },
        { value: 'ASSET_CONDITION_BY_BRANCH', label: 'Asset Condition by Branch' },
        { value: 'ASSET_MAKE_MODEL_DENSITY', label: 'Asset Make Model Density' },
      ]
    },
    {
      category: 'Financial & Valuation Reports',
      reports: [
        { value: 'STRAIGHT_LINE_DEPRECIATION_FORECAST', label: 'Straight Line Depreciation Forecast' },
        { value: 'ASSET_VALUATION_BY_DEPARTMENT', label: 'Asset Valuation by Department' },
        { value: 'DEPARTMENTAL_ALLOCATION_VALUATION', label: 'Departmental Allocation Valuation' },
        { value: 'INTER_STATE_TRANSIT_VALUATION', label: 'Inter State Transit Valuation' },
        { value: 'HIGH_VALUE_ASSETS_REPORT', label: 'High Value Assets Report' },
        { value: 'RETIRED_ASSETS_SALVAGE_AUDIT', label: 'Retired Assets Salvage Audit' },
        { value: 'WARRANTY_EXPIRY_ALERT_REPORT', label: 'Warranty Expiry Alert Report' },
        { value: 'ACCUMULATED_MAINTENANCE_COST_RATIO', label: 'Accumulated Maintenance Cost Ratio' }
      ]
    },
    {
      category: 'Maintenance, Tickets & Repair Reports',
      reports: [
        { value: 'REPAIR_COST_BY_VENDOR', label: 'Repair Cost by Vendor' },
        { value: 'REPAIR_FREQUENCY', label: 'Repair Frequency' },
        { value: 'TICKETS_BY_PRIORITY_AND_STATUS', label: 'Tickets by Priority and Status' },
        { value: 'TICKETS_BY_STATUS', label: 'Tickets by Status' },
        { value: 'TICKETS_BY_EXPECTED_START_DATE', label: 'Tickets by Expected Start Date' },
        { value: 'TICKETS_BY_EXPECTED_END_DATE', label: 'Tickets by Expected End Date' },
        { value: 'MEAN_TIME_TO_REPAIR_MTTR', label: 'Mean Time to Repair (MTTR)' },
        { value: 'REPETITIVE_FAILURES_ALERT_LOG', label: 'Repetitive Failures Alert Log' },
        { value: 'TICKETS_RESOLVED_BY_TECHNICIAN', label: 'Tickets Resolved by Technician' },
        { value: 'PREVENTIVE_MAINTENANCE_ADHERENCE', label: 'Preventive Maintenance Adherence' },
        { value: 'TICKET_BACKLOG_AGING', label: 'Ticket Backlog Aging' }
      ]
    },
    {
      category: 'IoT, Health Monitoring & Inventory Reports',
      reports: [
        { value: 'ASSET_HEALTH_MONITORING_UPTIME', label: 'Asset Health Monitoring Uptime' },
        { value: 'OFFLINE_MONITORED_ASSETS_ALERT', label: 'Offline Monitored Assets Alert' },
        { value: 'STOCK_POINT_INVENTORY_VALUATION', label: 'Stock Point Inventory Valuation' },
        { value: 'GEOSPATIAL_ASSET_DENSITY', label: 'Geospatial Asset Density' },
        { value: 'OVER_ALLOCATED_STOCK_WARNING', label: 'Over Allocated Stock Warning' }
      ]
    },
    {
      category: 'Asset Allocation & Custody Reports',
      reports: [
        { value: 'ASSET_ALLOCATION_HISTORY_LOG', label: 'Asset Allocation History Log' },
        { value: 'EMPLOYEE_CUSTODY_LOAD_SUMMARY', label: 'Employee Custody Load Summary' },
        { value: 'ALLOCATION_STATUS_DURATIONS', label: 'Allocation Status Durations' },
        { value: 'PENDING_ALLOCATION_REQUESTS', label: 'Pending Allocation Requests' },
        { value: 'BULK_ALLOCATION_DISPATCH_DETAILS', label: 'Bulk Allocation Dispatch Details' },
        { value: 'MEASURABLE_QUANTITY_ALLOCATION', label: 'Measurable Quantity Allocation' },
        { value: 'ALLOCATION_RETURN_LATENCY', label: 'Allocation Return Latency' },
        { value: 'GEOSPATIAL_ALLOCATION_DENSITY', label: 'Geospatial Allocation Density' },
        { value: 'ALLOCATION_REJECTION_REASONS', label: 'Allocation Rejection Reasons' },
        { value: 'RE_ALLOCATION_VELOCITY', label: 'Re-Allocation Velocity' }
      ]
    },
    {
      category: 'Asset Transit & Logistics Reports',
      reports: [
        { value: 'TRANSIT_LATENCY_BY_ROUTE', label: 'Transit Latency by Route' },
        { value: 'GEOSPATIAL_TRANSIT_FLOWS', label: 'Geospatial Transit Flows' },
        { value: 'TRANSIT_STATUS_DENSITY', label: 'Transit Status Density' },
        { value: 'TRANSIT_DELIVERY_SLA_COMPLIANCE', label: 'Transit Delivery SLA Compliance' },
        { value: 'TRANSIT_REJECTION_ANALYSIS', label: 'Transit Rejection Analysis' },
        { value: 'HIGH_FREQUENCY_TRANSIT_ASSETS', label: 'High Frequency Transit Assets' },
        { value: 'TRANSIT_COORDINATE_DRIFT', label: 'Transit Coordinate Drift' },
        { value: 'PENDING_TRANSIT_DISPATCH_BACKLOG', label: 'Pending Transit Dispatch Backlog' }
      ]
    },
    {
      category: 'Stock Point',
      reports: [
        { value: 'STOCK_POINT_ASSETS_DETAIL', label: 'Stock Point Assets Detail' }
      ]
    }
  ];

  reportTypeOptions: any = [
    { id: 1, value: 'REPAIR_FREQUENCY', label: 'Repair Frequency' },
    { id: 3, value: 'ASSET_ACQUISITION_REPORT', label: 'Asset Acquisition Report' },
    { id: 3, value: 'ASSET_AGE', label: 'Asset Aging Report' },
    { id: 4, value: 'TICKETS_BY_STATUS', label: 'Tickets by Status' },
    { id: 5, value: 'TICKETS_BY_EXPECTED_START_DATE', label: 'Tickets by Expected Start Date' },
    { id: 6, value: 'TICKETS_BY_EXPECTED_END_DATE', label: 'Tickets by Expected End Date' }
  ];


  assetsAgingReportOptions: any = [
    { id: 1, value: 'less-than-one-year', label: 'Less than one year' },
    { id: 2, value: '1-2-years', label: '1-2 years' },
    { id: 3, value: '2-3-years', label: '2-3 years' },
    { id: 4, value: '3-4-years', label: '3-4 years' },
    { id: 4, value: '4-5-years', label: '4-5 years' },
    { id: 5, value: 'greater-than-5-years', label: 'Greater than 5 years' }
  ];

  stockPointAssetsDetailOptions: any = [
    { id: 1, value: 'STOCK_POINT_ASSETS_DETAIL', label: 'Stock Point Assets Detail' },
  ];

  ticketStatusOptions: any = [
    { id: 1, value: 'OPEN', label: 'Open' },
    { id: 2, value: 'RE_OPEN', label: 'Re-open' },
    { id: 3, value: 'PENDING', label: 'Pending' },
    { id: 4, value: 'COMPLETED', label: 'Completed' },
    { id: 5, value: 'PARTIALLY_COMPLETED', label: 'Partially Completed' },
    { id: 6, value: 'ASSIGNED', label: 'Assigned' },
    { id: 7, value: 'CLOSED', label: 'Closed' },
    { id: 8, value: 'NOTE', label: 'Note' }
  ];


  tableKeys: any[] = [];
  objectData: any = []
  dateError: boolean = false;
  fromDateIsToday: boolean = false;
  isResponse: boolean = false;
  pageNumber: number = 0;
  totalRecords: number = 0;
  first: number = 0;
  recordsPerPage: number = 10;
  tableSize: number = 10;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = Number(sessionStorage.getItem('cid'))
    this.getAllLocation()
  }

  getAllLocation() {
    this.generic_service.getAllLocation().subscribe(
      (res: any) => {
        this.locationList = res.response || []
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  onTableDataChange(event: any) {
    console.log(event)
    this.first = event.first;
    this.tableSize = event.rows;
    this.recordsPerPage = event.rows;
    this.pageNumber = event.page + 1;
    this.getReportSelection(this.pageNumber, this.recordsPerPage)
  }


  validateDates() {
    if (this.fromDate && this.toDate) {
      const from = new Date(this.fromDate);
      const to = new Date(this.toDate);

      // Rule 1: fromDate must not be greater than toDate
      this.dateError = from > to;

      // Rule 2: fromDate must not be today's date
      const today = new Date();
      const todayString = today.toISOString().split('T')[0]; // Format to 'yyyy-MM-dd'
      this.fromDateIsToday = this.fromDate === todayString;
    } else {
      this.dateError = false;
      this.fromDateIsToday = false;
    }
  }


  assetAcquisitionReport(pageNumber: any, recordsPerPage: any) {
    this.generic_service.assetAcquisitionReport(this.fromDate, this.toDate, pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        console.log(response)

        this.objectData = response.response.queryResponse

        if (this.objectData.length > 0) {
          this.tableKeys = Object.keys(this.objectData[0]);
        }
        this.totalRecords = response.response.totalRecords
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getReportSelection1(pageNumber: any, recordsPerPage: any) {
    if (this.assetReportIdName == '') {
      this.toastr.error("please select report");
      return
    }

    const body = {
      "assetReportIdName": this.assetReportIdName,
      "startDate": this.fromDate,
      "endDate": this.toDate,
      "status": this.status,
      "pageSize": recordsPerPage,
      "pageNumber": pageNumber,
      "cid": this.cid
    }

    this.generic_service.getReportSelection(body).subscribe(
      (response: any) => {
        console.log(response)

        this.objectData = response.response.queryResponse


        if (this.objectData.length > 0) {
          this.tableKeys = Object.keys(this.objectData[0]);
        }
        this.totalRecords = response.response.totalRecords
      },
      (error: any) => {
        console.log(error)
      }
    )
  }




  isExcelDownload: any = false

  downloadExcel1() {

    if (this.isExcelDownload) return;

    this.isExcelDownload = true;

    const fileName = "report";
    // const fileName = prompt("Enter file name:", "report");

    // if (!fileName) {
    //   return;
    // }

    if (!this.objectData || this.objectData.length === 0) {
      console.warn("No data available to export");
      return;
    }

    const data: any[] = this.objectData;

    // Convert JSON to worksheet
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    // Create workbook
    const workbook: XLSX.WorkBook = {
      Sheets: { Report: worksheet },
      SheetNames: ['Report']
    };

    // Export workbook to Excel file
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    const blob: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    // File name with `.xlsx`
    FileSaver.saveAs(blob, `${fileName}.xlsx`);
  }

  downloadExcel() {
    if (this.isExcelDownload) return;
    this.isExcelDownload = true;
    this.toastr.info("Excel download in progress...", "Loading");

    let startDateToSend = this.fromDate;
    let endDateToSend = this.toDate;

    // Convert to epoch only for these report types
    const requiresEpoch = [
      "TICKETS_BY_EXPECTED_START_DATE",
      "TICKETS_BY_EXPECTED_END_DATE"
    ];

    if (requiresEpoch.includes(this.assetReportIdName)) {
      startDateToSend = this.toEpoch(this.fromDate);
      endDateToSend = this.toEpoch(this.toDate);
    }

    const body = {
      assetReportIdName: this.assetReportIdName,
      startDate: startDateToSend,
      endDate: endDateToSend,
      status: this.status,
      locationId: this.locationId,
      stockPointId: this.locationId || null,
      pageSize: this.totalRecords,
      pageNumber: 1,
      cid: this.cid
    };

    this.generic_service.amsAssetReportsSelection(body).subscribe(
      (response: any) => {
        console.log(response);

        const fileName = "report";
        const objectData: any = response.response.queryResponse;

        if (!objectData || objectData.length === 0) {
          console.warn("No data available to export");
          this.isExcelDownload = false;
          this.toastr.error("No data available to export");
          return;
        }

        const data: any[] = objectData.map((item: any) => {
          const newItem = { ...item };
          for (const key in newItem) {
            const val = newItem[key];
            if (val && !isNaN(Number(val)) && Number(val) > 1000000000000) {
              const keyLower = key.toLowerCase();
              if (keyLower.includes('date') || keyLower.includes('time') || keyLower.includes('created') || keyLower.includes('updated') || keyLower.includes('at')) {
                const dateObj = new Date(Number(val));
                newItem[key] = dateObj.toLocaleString(); // converts to readable format
              }
            }
          }
          return newItem;
        });

        // Convert JSON to worksheet
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

        // Create workbook
        const workbook: XLSX.WorkBook = {
          Sheets: { Report: worksheet },
          SheetNames: ['Report']
        };

        // Export workbook to Excel file
        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });

        const blob: Blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        // File name with `.xlsx`
        FileSaver.saveAs(blob, `${fileName}.xlsx`);
        this.isExcelDownload = false;
        this.toastr.success("Excel downloaded successfully.");
      },
      (error: any) => {
        console.log(error);
        this.isExcelDownload = false;
        this.toastr.error("Excel download failed.");
      }
    )

  }


  refreshAll() {

    this.assetReportIdName = ""
    this.selectedCategoryObj = null;
    this.isResponse = false

    this.isFromDate = true;
    this.isToDate = true;
    this.isStatus = false;
    this.isLocation = false;

    this.objectData = []

    this.toDate = "";
    this.fromDate = "";
    this.status = "";
    this.locationId = "";
    this.first = 0;
    this.pageNumber = 1;
    this.totalRecords = 0;
  }

  onCategoryChange() {
    this.assetReportIdName = "";
    this.reportChange("");
  }

  reportChange(report: string) {
    // Show dates for all reports
    this.isFromDate = true;
    this.isToDate = true;
    this.isStatus = false;
    this.isLocation = false;

    this.objectData = []

    // Reset values
    this.toDate = "";
    this.fromDate = "";
    this.status = "";
    this.locationId = "";
    this.first = 0;
    this.pageNumber = 1;
    this.totalRecords = 0;

    if (report === "TICKETS_BY_STATUS" || report === "TICKETS_BY_PRIORITY_AND_STATUS") {
      this.isStatus = true;
    }

    if (report === "STOCK_POINT_ASSETS_DETAIL") {
      this.isFromDate = false;
      this.isToDate = false;
      this.isLocation = true;
    }
  }

  reportChange1(report: string) {
    const config = {
      REPAIR_FREQUENCY: { from: true, to: true, status: false },
      WARRANTY_EXPIRY: { from: true, to: true, status: false },
      ASSET_ACQUISITION_REPORT: { from: true, to: true, status: false },
      TICKETS_BY_STATUS: { from: false, to: false, status: true },
      TICKETS_BY_EXPECTED_START_DATE: { from: true, to: false, status: false },
      TICKETS_BY_EXPECTED_END_DATE: { from: false, to: true, status: false },
    } as any;

    // Reset values
    this.toDate = "";
    this.fromDate = "";
    this.status = "";

    const selected = config[report] || { from: false, to: false, status: false };

    this.isFromDate = selected.from;
    this.isToDate = selected.to;
    this.isStatus = selected.status;
  }


  setDateRange(range: string) {
    console.log(range)
    const today = new Date();

    const format = (date: Date) =>
      date.toISOString().split('T')[0]; // yyyy-mm-dd

    switch (range) {
      case "less-than-one-year":
        this.fromDate = format(new Date(today.setFullYear(today.getFullYear() - 1)));
        this.toDate = format(new Date());
        break;

      case "1-2-years":
        this.fromDate = format(new Date(new Date().setFullYear(new Date().getFullYear() - 2)));
        this.toDate = format(new Date(new Date().setFullYear(new Date().getFullYear() - 1)));
        break;

      case "2-3-years":
        this.fromDate = format(new Date(new Date().setFullYear(new Date().getFullYear() - 3)));
        this.toDate = format(new Date(new Date().setFullYear(new Date().getFullYear() - 2)));
        break;

      case "3-4-years":
        this.fromDate = format(new Date(new Date().setFullYear(new Date().getFullYear() - 4)));
        this.toDate = format(new Date(new Date().setFullYear(new Date().getFullYear() - 3)));
        break;

      case "4-5-years":
        this.fromDate = format(new Date(new Date().setFullYear(new Date().getFullYear() - 5)));
        this.toDate = format(new Date(new Date().setFullYear(new Date().getFullYear() - 4)));
        break;

      case "greater-than-5-years":
        this.fromDate = "1900-01-01";
        this.toDate = format(new Date(new Date().setFullYear(new Date().getFullYear() - 5)));
        break;

      default:
        this.fromDate = "";
        this.toDate = "";
    }

    console.log(this.fromDate)
    console.log(this.toDate)
  }

  private toEpoch(dateString: string): number | null {
    return dateString ? new Date(dateString).getTime() : null;
  }

  getReportSelection(pageNumber: any, recordsPerPage: any) {
    // if (pageNumber === 1) {
    //   this.first = 0;
    //   this.pageNumber = 1;
    // }

    // this.objectData = []

    // VALIDATION
    if (!this.assetReportIdName) {
      this.toastr.error("Please select report");
      return;
    }

    // Reports that require BOTH dates
    const requiresBothDates = [
      "REPAIR_FREQUENCY",
      "WARRANTY_EXPIRY",
      "ASSET_ACQUISITION_REPORT"
    ];

    // Reports that require ONLY start date
    const requiresStartDate = [
      "TICKETS_BY_EXPECTED_START_DATE"
    ];

    // Reports that require ONLY end date
    const requiresEndDate = [
      "TICKETS_BY_EXPECTED_END_DATE"
    ];

    // Reports that require STATUS
    const requiresStatus = [
      "TICKETS_BY_STATUS"
    ];

    // Validate start date
    if (requiresStartDate.includes(this.assetReportIdName) || requiresBothDates.includes(this.assetReportIdName)) {
      if (!this.fromDate) {
        this.toastr.error("Please select start date");
        return;
      }
    }

    // Validate end date
    if (requiresEndDate.includes(this.assetReportIdName) || requiresBothDates.includes(this.assetReportIdName)) {
      if (!this.toDate) {
        this.toastr.error("Please select end date");
        return;
      }
    }

    // Validate status
    if (requiresStatus.includes(this.assetReportIdName)) {
      if (!this.status) {
        this.toastr.error("Please select status");
        return;
      }
    }

    if (this.assetReportIdName === "STOCK_POINT_ASSETS_DETAIL") {
      if (!this.locationId) {
        this.toastr.error("Please select location");
        return;
      }
    }

    // DATE COMPARISON — Only if both dates exist
    if (this.fromDate && this.toDate) {
      const from = new Date(this.fromDate).getTime();
      const to = new Date(this.toDate).getTime();

      if (from > to) {
        this.toastr.error("Start date cannot be greater than end date");
        return;
      }
    }


    let startDateToSend = this.fromDate;
    let endDateToSend = this.toDate;

    // Convert to epoch only for these report types
    const requiresEpoch = [
      "TICKETS_BY_EXPECTED_START_DATE",
      "TICKETS_BY_EXPECTED_END_DATE"
    ];

    if (requiresEpoch.includes(this.assetReportIdName)) {
      startDateToSend = this.toEpoch(this.fromDate);
      endDateToSend = this.toEpoch(this.toDate);
    }

    const body = {
      assetReportIdName: this.assetReportIdName,
      startDate: startDateToSend,
      endDate: endDateToSend,
      status: this.status,
      locationId: Number(this.locationId),
      stockPointId: Number(this.locationId) || null,
      pageSize: recordsPerPage,
      pageNumber: pageNumber,
      cid: this.cid
    };
    console.log(body)

    this.isLoading = true;
    this.generic_service.amsAssetReportsSelection(body).subscribe(
      (response: any) => {
        console.log(response);

        this.isLoading = false;
        this.isResponse = true

        this.objectData = response.response.queryResponse;

        if (this.objectData.length > 0) {
          this.tableKeys = Object.keys(this.objectData[0]);
        }

        this.totalRecords = response.response.totalRecords;
      },
      (error: any) => {
        console.log(error);
        this.isLoading = false;
        this.objectData = []
        // this.toastr.error(error.error.errors[0].description);
      }
    );
  }


  dashboardQueryTemp() {
    this.generic_service.dashboardQueryTemp().subscribe(
      (response: any) => {
        console.log(response)
      },
      (error: any) => {
        console.log(error);
      }
    );
  }



}
